import { Grid, Text } from "@pushpress/shared-components";
import React, { ReactNode } from "react";
import { switchPlanFormStyles } from "../SwitchPlanForm.styles";

type SectionTitleAndDescriptionProps = {
  title: ReactNode;
  description: ReactNode;
};

function SectionTitleAndDescription({
  title,
  description,
}: SectionTitleAndDescriptionProps) {
  return (
    <Grid container item xs={12} alignItems="center" wrap="nowrap">
      <Text variant="heading-5" weight="600" whiteSpace="nowrap">
        {title}
      </Text>
      <Text
        variant="body-lg"
        color="wolf-800"
        className="pl-3"
        whiteSpace="nowrap"
        style={switchPlanFormStyles.descriptionStyle}
      >
        {description}
      </Text>
    </Grid>
  );
}

export default SectionTitleAndDescription;
